import {
   AirplaneSquare, Text, Document, Lock, AlignBottom, ArrangeVertical, Box2, Building3, Camera,
   Car, Gps, Setting2, Speedometer, Clipboard, SearchZoomIn, PenTool, Star, Routing, RecoveryConvert,
   StatusUp, People, MouseCircle, GlobalSearch, BackwardItem, Printer, MobileProgramming, NoteText,
   CloudConnection, HambergerMenu, Convert, Layer, Coin, Notepad2, Trash,
   FilterRemove, Screenmirroring, Tag, SearchNormal, Import, DocumentCloud, Status,
   TickCircle, Sort, SaveAdd,
   ArrowRight,
   Back,
   Eye,
   ArrowRotateLeft,
   Refresh,
   AddSquare,
   Global,
   User,
   Book,
   CloudFog,
   Sun1,
   SunFog
} from "iconsax-react";
import { cloneElement } from "react";
import { BsChevronDoubleUp, BsChevronDoubleDown, BsChevronRight, BsCheck, BsFillPencilFill, BsTrashFill, BsX, BsArrowUpRightSquareFill, BsHouseUpFill, BsCheckCircle, BsExclamationTriangle, BsXLg, BsBicycle, BsCarFront, BsDownload, BsPersonWalking, BsHeartFill, BsFillPinAngleFill, BsChevronDown, BsPrinter, BsArrowLeftRight, BsFileEarmarkPdf, BsGlobe, BsImage, BsCaretDown, BsCaretDownFill, BsCaretUp, BsCaretUpFill, BsPalette2, BsCloud, BsCloudArrowUp, BsCloudSlash, BsGearFill, BsInfo, BsPlusLg, BsStarFill, BsFillCircleFill, BsList, BsSignpost2Fill, BsHouse, BsLayers, BsExclamationTriangleFill, BsPostcard, BsQuestion, BsLink45Deg, BsSave, BsGear, BsGearWide, BsXSquare, BsLock, BsPostcardFill, BsCarFrontFill, BsFileEarmark, BsFileEarmarkExcel, BsFiletypeCsv } from "react-icons/bs";
import { FiAlignRight, FiBell, FiCopy, FiMove } from "react-icons/fi";
import { MdBlock, MdCenterFocusStrong, MdError, MdImage, MdInfo, MdLegendToggle, MdMessage, MdPalette, MdQueryStats } from "react-icons/md";
import { PiCircle, PiFolderDashed, PiGraphFill, PiLineSegment, PiMouseLeftClickFill, PiMouseRightClickFill, PiPolygon, PiTrash } from "react-icons/pi";
import { TbFilter, TbFilterMinus, TbRotate, TbStack, TbStackMiddle } from "react-icons/tb";
import RushHour from '../svg/catchment/rushHour.svg?react';
import Transit from '../svg/catchment/transit_2.svg?react';
import TransitBike from '../svg/catchment/transit_bike.svg?react';
import { LuSigma } from "react-icons/lu";
import { BiBug, BiCheck, BiCrop, BiCross, BiMinus } from "react-icons/bi";
import { HiDotsVertical, HiFolderAdd, HiOutlineChevronUp } from "react-icons/hi";
import { FaRegHeart, FaRegClock, FaChevronLeft, FaChevronRight, FaEye, FaEyeSlash, FaEraser } from "react-icons/fa";
import { AiFillCamera, AiFillCheckCircle, AiFillEdit, AiFillExclamationCircle, AiFillEye, AiFillFlag, AiOutlineUserSwitch } from "react-icons/ai";
import { GiPentarrowsTornado } from "react-icons/gi";
import { TiArrowBack } from "react-icons/ti";
import { IoMdPin } from "react-icons/io";



const iconMap = {
   "Stevns": <Speedometer />,
   "AdjustUpDown": <ArrangeVertical />,
   "ObliqueFoto": <Camera />,
   "Buildings": <Building3 />,
   "Roads": <Car />,
   "3DEffect": <Box2 />,
   "HeightMap": <AlignBottom />,
   "Airports": <AirplaneSquare />,
   "Text": <Text />,
   "Settings": <Setting2 />,
   "UserLocation": <Gps />,
   "Documents": <Document />,
   "ServitutErklæring": <MobileProgramming />,
   "Discover": <SearchZoomIn />,
   "Draw": <PenTool />,
   "POI": <Star />,
   "Catchment": <Routing />,
   "BNBO": <RecoveryConvert />,
   "FRP": <StatusUp />,
   "Demographics": <People />,
   "CircleSelect": <MouseCircle />,
   "Explorer": <GlobalSearch />,
   "Ownership": <BackwardItem />,
   "Plot": <Printer />,
   "DataRapports": <NoteText />,
   "JobService": <CloudConnection />,
   "JPB": <Coin />,
   "ConflictSearch": <Clipboard />,
   "Menu": <HambergerMenu />,
   "Layers": <Layer />,
   "Guide": <Notepad2 />,
   "SwitchLicense": <Convert />,
   "Lock": <Lock />,
   "Remove": <Trash />,
   "Import": <Import />,
   "Search": <SearchNormal />,
   "UploadedDocuments": <DocumentCloud />,
   "Tags": <Tag />,
   "Status": <Status />,
   "AdjustMap": <Screenmirroring />,
   "RemoveFilter": <FilterRemove />,
   "RadioSelected": <TickCircle />,
   "Sort": <Sort />,
   "Send": <SaveAdd />,
   "GoForward": <ArrowRight />,
   "GoBack": <Back />,
   "View": <Eye />,
   "Reload": <ArrowRotateLeft />,
   "Auto": <Refresh />,
   "Global": <Global />,
   "AddToMap": <AddSquare />,
   "Login": <User />,

   "New": <Sun1 />,
   "Old": <SunFog />,
   "Legacy": <CloudFog />,
} as const;

const simpleIconMap = {
   "sortAsc": <BsChevronDoubleUp />,
   "sortDesc": <BsChevronDoubleDown />,
   "collapsable": <BsChevronRight />,
   "expandable": <BsChevronDown />,
   "accept": <BsCheck />,
   "edit": <BsFillPencilFill />,
   "delete": <BsTrashFill />,
   "delete2": <BsX />,
   "leftClick": <PiMouseLeftClickFill />,
   "rightClick": <PiMouseRightClickFill />,
   "move": <FiMove />,
   "rotate": <TbRotate />,
   "block": <MdBlock />,
   "adjustToScreen": <MdCenterFocusStrong />,
   "addToMapSFE": <BsHouseUpFill />,
   "addToMap": <BsArrowUpRightSquareFill />,
   "error": <MdError />,
   "info": <MdInfo />,
   "question": <BsQuestion />,
   "dismiss": <BsXLg />,
   "issues": <BsExclamationTriangle />,
   "allOk": <BsCheckCircle />,
   "car": <BsCarFront style={{ width: "1em", height: "1em" }} />,
   "bike": <BsBicycle style={{ width: "1em", height: "1em" }} />,
   "walk": <BsPersonWalking style={{ width: "1em", height: "1em" }} />,
   "transit": <Transit style={{ width: "1em", height: "1em" }} />,
   "transitorbike": <TransitBike style={{ width: "1em", height: "1em" }} />,
   "rushHour": <RushHour style={{ width: "1em", height: "1em" }} />,
   "tæl": <LuSigma />,
   "download": <BsDownload />,
   "favorite": <BsHeartFill />,
   "fastgør": <BsFillPinAngleFill />,
   "checkmark": <BiCheck />,
   "minus": <BiMinus />,
   "plot": <BsPrinter />,
   "ownership": <PiGraphFill />,
   "print": <BsPrinter />,
   "leftRightBar": <BsArrowLeftRight />,
   "link": <BsGlobe />,
   "image": <BsImage />,
   "DrawLineSegment": <PiLineSegment />,
   "DrawPolygon": <PiPolygon />,
   "DrawCircle": <PiCircle />,
   "DrawTrash": <PiTrash />,
   "closeSingle": <HiOutlineChevronUp />,

   "expandUp": <BsCaretUp />,
   "expandUpActive": <BsCaretUpFill />,
   "expandDown": <BsCaretDown />,
   "expandDownActive": <BsCaretDownFill />,
   "selectColor": <BsPalette2 />,

   // GroupedLayers
   "favoriteLayers": <FaRegHeart />,
   "recentLayers": <FaRegClock />,
   "expandLayer": <BsChevronRight />,
   "removeLayer": <BsXLg />,
   "addFavoriteLayer": <BsPlusLg />,
   "layerSettings": <BsGearFill />,
   "downloadLayerSettings": <BsDownload />,

   "layerInfo": <BsInfo />,
   "publishLayer": <BsCloudArrowUp />,
   "unpublishLayer": <BsCloudSlash />,
   "publishedLayer": <BsCloud />,

   "addFolder": <HiFolderAdd />,
   "pointRadius": <BsFillCircleFill />,


   "style": <MdPalette />,
   "polygon": <MdImage />,
   "point": <IoMdPin />,
   "comment": <MdMessage />,

   // Quality, using colors / Import quality
   "q_good": <AiFillCheckCircle style={{ color: "#5cb85c" }} />,
   "q_bad": <AiFillExclamationCircle style={{ color: "#d9534f" }} />,
   "q_error": <AiFillExclamationCircle style={{ color: "red" }} />,
   "q_warning": <AiFillFlag style={{ color: "#f0ad4e" }} />,
   "q_userVerified": <AiFillEdit style={{ color: "#5cb85c" }} />,
   "q_unknown": <AiFillEye style={{ color: 'grey' }} />,

   "debugging": <BiBug />,
   "rating": <BsStarFill />,
   "emptyGroup": <PiFolderDashed />,
   "menu": <HiDotsVertical />,

   "proxyLayer": <TbStackMiddle style={{ color: "red" }} />,
   "directLayer": <TbStack style={{ color: "green" }} />,
   "lessThan": <FaChevronLeft />,
   "greaterThan": <FaChevronRight />,

   "list": <BsList />,
   "copy": <FiCopy />,

   "propertyInfo": <BsPostcardFill />,
   "catchment": <BsCarFrontFill />,

   "spatialFilter": <TbFilter />,
   "spatialFilterInverse": <TbFilterMinus />,
   "spatialFilterPolygon": <BiCrop />,

   "property": <BsHouse />,

   // Legend

   "legend": <MdLegendToggle />,
   "layer": <BsLayers />,
   "layerWarning": <BsExclamationTriangleFill style={{ color: "#cca164" }} />,


   "pointDistance": <GiPentarrowsTornado />,
   "obliquePhoto": <AiFillCamera />,
   "streetView": <BsSignpost2Fill />,

   "kortviser": <span className="falseIcon" >K</span>,
   "lifaOIS": <span className="falseIcon" >L</span>,
   "visSamletFastEjendom": <span className="falseIcon" >S</span>,
   "visMatrikel": <span className="falseIcon" >M</span>,
   "visVurderingsEjendom": <span className="falseIcon" >V</span>,
   "historiskekort": <span className="falseIcon" >H</span>,
   "dotInfo": <BiCross />,

   "partialChecked": <BiMinus />,
   "checked": <BiCheck />,

   "notification": <FiBell />,
   "mapDescription": <FiAlignRight />,

   "geolocation": <BsPostcard />,

   "popout": <Book />,

   "show": <FaEye />,
   "hide": <FaEyeSlash />,
   "erase": <FaEraser />,

   "inspectFeature": <MdQueryStats />,
   "saveMap": <BsSave />,
   "mapLink": <BsLink45Deg />,
   "cloudUpload": <BsCloudArrowUp />,
   "settings": <BsGear />,
   "customerSettings": <BsGearWide />,
   "changePassword": <BsLock />,
   "logout": <BsXSquare />,
   "goBack": <TiArrowBack />,
   "information": <BsInfo />,
   "switchLicense": <AiOutlineUserSwitch />,


   "xlsx": <BsFileEarmarkExcel size={"1em"} />,
   "csv": <BsFiletypeCsv size={"1em"} />,
   "pdf": <BsFileEarmarkPdf size={"1em"} />,
   "unknownFile": <BsFileEarmark size={"1em"} />

}


export type MIBVariants = "Linear" | "Outline" | "Broken" | "Bold" | "Bulk" | "TwoTone" | (string & {});
export const MIBIcons = Object.keys(iconMap) as (keyof typeof iconMap)[];
export const SimpleMIBIcons = Object.keys(simpleIconMap) as (keyof typeof simpleIconMap)[];

export type MIBIBaseProps = React.SVGAttributes<SVGElement>
export function MIBIcon<T extends keyof typeof iconMap | keyof typeof simpleIconMap>(props: { icon: T, variant?: T extends keyof typeof iconMap ? MIBVariants : never, style?: React.CSSProperties, } & MIBIBaseProps) {
   if (!(props.icon in iconMap) && !(props.icon in simpleIconMap)) {
      return <div style={{ width: "1em", height: "1em", backgroundColor: "red", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "12px" }}>?</div>;
   }
   if (props.icon in iconMap) {
      return (cloneElement(iconMap[props.icon as keyof typeof iconMap], { ...props, id: props.icon, style: { width: "1em", height: "1em", ...props.style }, variant: props.variant }))
   }
   let PreStyle = simpleIconMap[props.icon as keyof typeof simpleIconMap].props.style || {};

   return (cloneElement(simpleIconMap[props.icon as keyof typeof simpleIconMap], { ...props, id: props.icon, style: { ...PreStyle, ...props.style } }))
}